import { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";

const GETRESERVEDPURCHASES = gql`
  query ($paginateInput: PaginateInput!, $searchInput: PurchaseSearchInput!) {
    getPurchases(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      product {
        name
        id
      }
      startAt
      endAt
    }
  }
`;

const useReservedHours = (selectedMeetingRoom, selectedMeetingDate) => {
  const [reservedHours, setReservedHours] = useState([]);
  const [reservedPurchases, setReservedPurchases] = useState(null);

  const [getReservedPurchasesList, reservedPurchasesList] = useLazyQuery(
    GETRESERVEDPURCHASES,
    {
      fetchPolicy: "no-cache",
      onCompleted({ getPurchases }) {
        setReservedPurchases(getPurchases);
      },
    }
  );
  useEffect(() => {
    if (selectedMeetingRoom) {
      getReservedPurchasesList({
        variables: {
          paginateInput: {
            page: 1,
            perPage: 100,
          },
          searchInput: {
            purchaseType: ["RESERVED", "PRODUCT"],
          },
        },
      });
    }
  }, [selectedMeetingRoom]);
  const calcReservedHours = () => {
    const selectedMeetingRoomReservedObjs = reservedPurchases.filter(
      (rp) => rp?.product?.id === selectedMeetingRoom
    );

    const reservedTimesOfDay = selectedMeetingRoomReservedObjs?.filter(
      (selectedMT) =>
        moment(selectedMT.startAt).format("YYYY-M-D") ===
          moment(selectedMT.endAt).format("YYYY-M-D") &&
        moment(selectedMT.endAt).format("YYYY-M-D") ===
          moment(selectedMeetingDate?.dateString, "jYYYY/jMM/jDD").format(
            "YYYY-M-D"
          )
    );

    const reservedHoursOfDay = [];
    reservedTimesOfDay?.map((reserveTime) => {
      const duration = {
        startAt: moment(reserveTime?.startAt).format("HH:mm"),
        endAt: moment(reserveTime?.endAt).format("HH:mm"),
      };
      reservedHoursOfDay.push(duration);
    });
    setReservedHours(reservedHoursOfDay);
  };

  useEffect(() => {
    if (reservedPurchases && selectedMeetingRoom && selectedMeetingDate)
      calcReservedHours();
  }, [reservedPurchases, selectedMeetingRoom, selectedMeetingDate]);


  return reservedHours;
};


export default useReservedHours;